import React, { useRef, useState, useEffect } from "react";
import { Canvas, useThree } from "@react-three/fiber";
import { ContactShadows, Environment } from "@react-three/drei";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";
import { useDispatch, useSelector } from "react-redux";
import * as THREE from "three";
import "../Styles/3d.css";
import JerseyModel from "./ShirtModel.jsx";
import { resetModifiedGLB, setModifiedGLB } from "../Redux/Cart_System.js";
import { addToCart } from "../Services/Operations/ProductAPI.js";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import state from "./index.js";
import modelConfig1 from "./modelConfig1.js";
import { useSnapshot } from "valtio";
import '../Styles/toolbarDesign.css';
import { downloadCanvasToImage } from "./Customizer.jsx";

const SceneCapture = ({ sceneRef }) => {
  const { scene } = useThree();
  sceneRef.current = scene;
  return null;
};
const Canva = ({ menuSlug, subcategorySlug, glbBlob, gltfRef ,isEditingDraft  }) => {
  const shirtModelRef = useRef();
  const snap = useSnapshot(state);
  const [loading, setLoading] = useState(false);
  const { tokenDetails } = useSelector((state) => state.user);
  const { selectedSize, glbId } = useSelector((state) => state.cart);
  const modifiedGLB = useSelector((state) => state.cart.modifiedGLB);
  const [exportedGLB, setExportedGLB] = useState(null);
  const dispatch = useDispatch();
  const sceneRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  // const gltfRef = useRef(null);
  const [isMobile,setIsMobile]=useState(window.innerWidth<767)

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const currentProduct = state.products[state.currentProductId];

  const convertTextureToCanvas = (texture) => {
    if (!texture?.image) return texture;

    const canvas = document.createElement("canvas");
    canvas.width = texture.image.width;
    canvas.height = texture.image.height;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(texture.image, 0, 0);

    const newTexture = new THREE.CanvasTexture(canvas);
    newTexture.needsUpdate = true;
    return newTexture;
  };
const exportGLB = async () => {
  setLoading(true);
  if (!gltfRef.current) {
    console.error("Scene is not available!");
    return;
  }

  // 1. CLONE the scene to prevent visual glitches on the UI
  const exportScene = gltfRef.current.scene.clone(true);
  
  // 2. We must also clone the materials/textures manually because .clone() 
  // often keeps references to the original materials
  exportScene.traverse((child) => {
    if (child.isMesh && child.material) {
      child.material = child.material.clone();
      
      const materials = Array.isArray(child.material) 
        ? child.material 
        : [child.material];
      
      materials.forEach(mat => {
        if (mat.map && mat.map instanceof THREE.CanvasTexture) {
          // Create a static texture from the canvas for the exporter
          const canvas = mat.map.image;
          const texture = new THREE.CanvasTexture(canvas);
          texture.colorSpace = THREE.SRGBColorSpace;
          mat.map = texture;
        }
        mat.needsUpdate = true;
      });
    }
  });

  // Small delay to ensure the cloned scene's matrices are updated
  await new Promise(resolve => setTimeout(resolve, 100));

  const exporter = new GLTFExporter();

  try {
    // 3. Export the CLONED scene
    const result = await exporter.parseAsync(exportScene, {
      binary: true,
    });

    if (result instanceof ArrayBuffer) {
      const blob = new Blob([result], { type: "model/gltf-binary" });
      console.log("GLB Blob size:", blob.size);
      const fileURL = URL.createObjectURL(blob);
      
      const glbData = {
        fileURL,
        fileName: "custom_model.glb",
        fileType: "model/gltf-binary",
      };
      dispatch(setModifiedGLB(glbData));
    }
  } catch (error) {
    console.error("GLB Export error:", error);
  } finally {
    setLoading(false);
    // 4. Clean up the clone from memory
    exportScene.clear();
  }
};

  const sendToGLB = async () => {
    try {
      const pngDataUrl = shirtModelRef.current?.capturePng?.();

      if (!modifiedGLB?.fileURL) {
        toast.error("First do export please");
        return;
      }
      if (!tokenDetails) {
        toast.error("Please login or Signup");
        return;
      }
      if (!selectedSize) {
        toast.error("Select size please.");
        return;
      }

      const newKey = state.newKey;
      const imagesPattern = state.imagesPattern;

      const modelSettings = modelConfig1[newKey];
      let updatedSettings;

      if (modelSettings) {
        updatedSettings = {
          ...modelSettings,
          frontText: state.frontText,
          backText: state.backText,
          frontNumber: state.frontNumber,
          backNumber: state.backNumber,
          frontLogo: state.frontLogo,
          backLogo: state.backLogo,
          Colors: state.partColors,
          textFonts: state.textFonts,
          numberFonts: state.numberFonts,
        };
      }

      const response = await fetch(modifiedGLB.fileURL);
      const blob = await response.blob();
      console.log("GLB Blob size:", blob);
      const file = new File([blob], modifiedGLB.fileName, {
        type: "model/gltf-binary",
      });

      const formData = new FormData();
      formData.append("userfile", file);

      formData.append(
        "cart",
        JSON.stringify({
          glb: [
            {
              glb_id: glbId,
              qty: "1",
              size_id: selectedSize?.id,
              settings: updatedSettings,
              image: pngDataUrl,
            },
          ],
        })
      );

      const imageArray = Object.entries(imagesPattern).map(([position, pattern]) => {
        const base64 = pattern.image;
        const byteString = atob(base64.split(",")[1]);
        const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];

        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        const blob = new Blob([ab], { type: mimeString });
        const file = new File([blob], `${position}_pattern.png`, {
          type: mimeString,
        });

        return { position, file };
      });

      const cartData = imageArray.map(({ position }) => ({ position }));

      formData.append("cartData", JSON.stringify(cartData));
      imageArray.forEach(({ file }, index) => {
        formData.append(`cartImage[${index}]`, file);
      });

      const responseUpload = await addToCart(formData, tokenDetails);

      if (responseUpload.success === true) {
        toast.success("Product added successfully!");
        dispatch(resetModifiedGLB());
        navigate("/cart");
      } else {
        toast.error("Upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("An error occurred while uploading.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (modifiedGLB?.fileURL) {
      sendToGLB();
    }
  }, [modifiedGLB]);

  function resetState() {
    state.updateTrigger = 0;
    state.intro = false;
    state.color = "";
    state.frontText = "";
    state.backText = "";
    state.frontNumber = "";
    state.backNumber = "";
    state.frontLogo = "";
    state.backLogo = "";
    state.imagesPattern = {};
    state.viewSide = "front";
    state.patternColors = {};
    state.selectedPattern = {};
    state.selectedFonts = "";
    state.textFonts = { front: "", back: "" };
    state.numberFonts = { front: "", back: "" };
    state.partColors = {};
    state.gradientColors = {};
  }
   const downloadCanvasToImage = () => {
   
    
      const canvas = document.querySelector("canvas");
      const dataURL = canvas.toDataURL();
      const link = document.createElement("a");
  
      link.href = dataURL;
      link.download = "canvas.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.location.reload();
    };

  return (
    <div className="main-viewport" style={{ paddingBottom: "60px" }}>
      <Canvas
        gl={{
          preserveDrawingBuffer: true,
          antialias: true,
          alpha: true,
          powerPreference: "high-performance",
        }}
        shadows
        dpr={isIOS ? [1, 1.2] : [1, 2]} // cap DPR on iOS
        className="canvas-viewPort"
        style={{ width: "100%", height: "79%" }}
      >
        <SceneCapture sceneRef={sceneRef} />
        <Environment preset="city" />
        <directionalLight
          position={[5, 5, 5]}
          intensity={2.5}
          castShadow
          shadow-mapSize={[1024, 1024]}
        />
        <ambientLight intensity={0.5} />
        <ContactShadows
          position={[0, -0.8, 0]}
          opacity={0.25}
          scale={10}
          blur={1.5}
          far={0.8}
        />
        <JerseyModel
           ref={shirtModelRef}
           gltfRef={gltfRef}
           menuSlug={menuSlug}
           subcategorySlug={subcategorySlug}
           glbBlob={glbBlob}
           isEditingDraft={isEditingDraft}
           currentProduct={currentProduct}
        />
      </Canvas>

      

      <div className="button-container " 
      style={{border:isMobile?"":"1px solid black",backgroundColor:"white",zIndex:1000,position:"fixed",bottom:isMobile?"70px":0,right:0,width:"100%",}}>

      
       {isMobile ?
       ""
        :
           <button
          className="send-btn2 send-btn3 continue-gradient"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: window.innerWidth < 567 ? "20px" : "",
            zIndex:1000,
            fontSize:"16px",fontWeight:"400"
          
          }}
          onClick={() => resetState()}
        >
          Reset
        </button>
        }

        <button
          onClick={() => setIsModalOpen(true)}
          className={`${isMobile?"continue-gradient":"send-btn1 continue-gradient"}`}
          style={{ display: "flex", alignItems: "center", justifyContent: "center" ,width:isMobile?"90%":"",zIndex:1050,  fontSize:"16px",fontWeight:"400",borderRadius:isMobile?"8px":""}}
        >
          {loading ? (
            <div
              style={{
                width: "20px",
                height: "20px",
                border: "3px solid rgba(255, 255, 255, 0.3)",
                borderTopColor: "#fff",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            ></div>
          ) : (
            "Add to Cart"
          )}
        </button>

        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content" style={{ width: "max-content" }}>
              <h2>Confirm Action</h2>
              <p>Are you sure you want to add to cart?</p>
              <div className="modal-buttons">
                <button
                  className="ok-button"
                  onClick={() => {
                     exportGLB();
                     setIsModalOpen(false);
                  }}
                >
                  OK
                </button>
                <button className="cancel-button" onClick={() => setIsModalOpen(false)}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Canva;

